"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRenderingQuestionnaireComplete = isRenderingQuestionnaireComplete;
exports.getSectionGroupById = getSectionGroupById;
exports.getSectionById = getSectionById;
exports.findFieldInRenderingQuestionnaire = findFieldInRenderingQuestionnaire;
const lodash_1 = __importDefault(require("lodash"));
const RepeatableExpansion_1 = require("../RepeatableExpansion");
// TODO @MultiInsured This goes elsewhere -- but where?
function isRenderingQuestionnaireComplete(questionnaire) {
    return lodash_1.default.every(questionnaire, ['completed', true]);
}
// TODO @MultiInsured -- Move these to a questionnaireQueries module
function getAllFieldGroups(questionnaire) {
    const sections = lodash_1.default.flatMap(questionnaire, 'sections');
    const subsections = lodash_1.default.flatMap(sections, 'subsections');
    return lodash_1.default.flatMap(subsections, 'fieldGroups');
}
function getAllFields(questionnaire) {
    const fieldGroups = getAllFieldGroups(questionnaire);
    return lodash_1.default.flatMap(fieldGroups, 'fields');
}
function getSectionGroupById(sectionGroups, id) {
    return lodash_1.default.find(sectionGroups, (sectionGroup) => sectionGroup.id === id);
}
function getSectionById(sectionGroup, id) {
    return lodash_1.default.find(sectionGroup.sections, (section) => section.id === id);
}
function findFieldInRenderingQuestionnaire(questionnaire, fieldId, repeatedIdentifiers) {
    const allFields = getAllFields(questionnaire);
    const targetId = (0, RepeatableExpansion_1.appendRepeatableInstancesToId)(fieldId, repeatedIdentifiers ?? {});
    return allFields.find((field) => field.id === targetId);
}
